export default {"src":"/_next/static/media/logo-full-bright.84c18f5e.svg","height":32,"width":90,"blurWidth":0,"blurHeight":0};